import styled from 'styled-components';

export const WarningWrapper = styled.div`
	display: flex;
	padding: 8px 16px;
	align-items: center;
	text-align: left;
	background-color: ${({ theme: { colors } }) => colors.warning};
`;
